import {
  ActiveState,
  EntityState,
  EntityStore,
  StoreConfig,
} from '@datorama/akita';
import { Injectable } from '@angular/core';
import { AbsenceListItem } from 'src/app/core/models/client-models';

/**
 * Absence Entity Store. Used to display list of Absences.
 */
export interface AbsenceItemsState
  extends EntityState<AbsenceListItem, number>,
    ActiveState {}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'absence-items', idKey: 'id' })
export class AbsenceItemsStore extends EntityStore<AbsenceItemsState> {
  constructor() {
    super();
  }
}
